<template>
  <div class="test-content">
    <transition name="bounce">
      <div v-show="!start" class="grey-container">
        <test-begin :number="levelId" @startTest="startTest"></test-begin>
      </div>
    </transition>

    <div class="test-container" v-if="!testEnd && start">
      <div v-if="isLoading" class="loading-task">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          color="#52b700"
        />
      </div>

      <div class="task-container">
        <div v-if="isWatch" class="card">
          <!-- <div class="card-header">ЦАГ</div> -->
          <!-- <vac
            class="card-body lef-time-vac"
            :end-time="new Date().getTime() + tesTime"
          >
            <div class="time" slot="process" slot-scope="{ timeObj }">
              <span class="time-now"> {{ ` ${timeObj.m}:${timeObj.s}` }}</span>
              <div class="time-label">
                <p>мин</p>
                <p>сек</p>
              </div>
            </div>

            <div class="time" slot="finish">
              <span class="time-now"> 00:00</span>
              <div class="time-label">
                <p>мин</p>
                <p>сек</p>
              </div>
            </div>
          </vac> -->
        </div>
        <div v-if="!isLoading">
          <div class="content task">
            <div class="col-md-11 d-flex">
              <i class="far fa-question-circle fn"></i>
              <div class="mr-1">{{ taskNumber }}.</div>
              <div class="task-text" v-html="jsonData.question"></div>
            </div>
            <div class="col-md-1 task-score">{{ jsonData.point }} оноo</div>
          </div>

          <div class="content choice">
            <i class="fas fa-dice-five fn"></i>
            <div v-for="(ans, idx) in answers" :key="idx">
              <div
                @click="selectAnswer(ans, idx)"
                v-bind:class="{
                  'choice-body': true,
                  selected: ans.isSelected,
                }"
              >
                <div class="choice-letter">{{ ans.value }}</div>
                <div class="choice-value" v-html="ans.text"></div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <button
              class="btn btn-success"
              @click="before"
              :disabled="taskNumber < 2"
            >
              өмнөх
            </button>

            <button class="btn btn-success" v-if="taskNumber < 9" @click="nextQuestion()">
              дараагийн
            </button>

            <button
              class="btn btn-success"
              v-if="8 < taskNumber"
              @click="lastQuestion"
            >
              сүүлийн
            </button>
          </div>
        </div>
      </div>
    </div>
    <test-completed :chosenList="chosenList" v-if="testEnd" />
  </div>
</template>

<script>
import Vue from "vue";
// import swal from "sweetalert";
import Swal from "sweetalert2";
import OwnerService from "../api-services/owner.service.js";
import { HalfCircleSpinner } from "epic-spinners";
import TestCompleted from "../components/TestCompleted.vue";
import TestBegin from "../components/TestBegin.vue";

export default {
  data() {
    return {
      jsonData: {},
      answers: [],
      questionIdList: [],
      categoryId: 0,
      levelId: 0,
      taskNumber: 1,
      isValue: null,
      id: null,
      isIndex: null,
      isLoading: true,
      isChecked: false,
      tesTime: 1201000,
      count: 1200,
      testEnd: false,
      start: true,
      isWatch: false,
      chosenList: [
        { qid: null, aid: null, score: 3, isIndex: null },
        { qid: null, aid: null, score: 3, isIndex: null },
        { qid: null, aid: null, score: 3, isIndex: null },
        { qid: null, aid: null, score: 4, isIndex: null },
        { qid: null, aid: null, score: 4, isIndex: null },
        { qid: null, aid: null, score: 4, isIndex: null },
        { qid: null, aid: null, score: 5, isIndex: null },
        { qid: null, aid: null, score: 5, isIndex: null },
        { qid: null, aid: null, score: 5, isIndex: null },
      ],
    };
  },
  components: {
    HalfCircleSpinner,
    TestCompleted,
    TestBegin,
  },
  methods: {
    async startTest() {
      this.start = true;
      await this.loadQuestion();
    },

    selectAnswer: function (ans, idx) {
      this.pause = !this.pause;
      this.answers.forEach((element) => {
        element.isSelected = false;
      });
      ans.isSelected = true;

      this.isChecked = true;
      this.isValue = ans.value;
      this.isIndex = idx;

      Vue.set(this.answers, this.answers.indexOf(ans), ans);
    },

    nextQuestion() {
      if (this.isChecked) {
        this.chosenList[this.taskNumber - 1].isIndex = this.isIndex;
        this.chosenList[this.taskNumber - 1].aid = this.isValue;
      }
      this.chosenList[this.taskNumber - 1].qid = this.questionIdList[
        this.taskNumber - 1
      ];
      this.taskNumber++;
      this.loadQuestion();
      this.isValue = null;
      this.isIndex = null;
    },

    before() {
      this.taskNumber--;
      this.loadQuestion();
    },

    lastQuestion: function () {
      if (this.isChecked) {
        this.chosenList[this.taskNumber - 1].isIndex = this.isIndex;
        this.chosenList[this.taskNumber - 1].aid = this.isValue;
      }
      this.chosenList[this.taskNumber - 1].qid = this.questionIdList[
        this.taskNumber - 1
      ];

      this.timeOut();
    },

    timeOut: function () {
      Swal.fire({
        icon: "warning",
        title: "Сорил дуусгах уу",
        showCancelButton: true,
        confirmButtonText: `Үр дүн харах`,
        cancelButtonText: `буцах`,
        confirmButtonColor: "#52b700",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Баяр хүргэе",
            text: "Сорил амжилттай дуусгалаа",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            this.testEnd = true;
          });
        }
      });
    },

    async loadQuestion() {
      this.isChecked = false;
      this.isLoading = true;
      const that = this;
      try {
        const resp = await OwnerService.sorilQuestion({
          angi: this.angiId,
          bagts: this.bagtsId,
          sorilNo: this.levelId,
          qid: this.questionIdList[this.taskNumber - 1],
        });
        that.isLoading = false;
        that.isWatch = true;
        that.answers[0] = {
          text: resp.data.a_one,
          value: "A",
          isSelected: false,
        };
        that.answers[1] = {
          text: resp.data.a_two,
          value: "B",
          isSelected: false,
        };
        that.answers[2] = {
          text: resp.data.a_three,
          value: "C",
          isSelected: false,
        };
        that.answers[3] = {
          text: resp.data.a_four,
          value: "D",
          isSelected: false,
        };
        that.answers[4] = {
          text: resp.data.a_five,
          value: "E",
          isSelected: false,
        };
        that.jsonData = resp.data;
        window.scrollTo(0, 0);
        that.$nextTick(() => {
          setTimeout(() => {
            if (window.MathJax) {
              window.MathJax.typeset();
            }
          }, 10);
        });
        if (that.chosenList[that.taskNumber - 1].isIndex !== null) {
          that.answers[
            that.chosenList[that.taskNumber - 1].isIndex
          ].isSelected = true;
        }
      } catch (ex) {
        console.log(ex);
      }
    },

    async loadQuestionList() {
      try {
        const resp = await OwnerService.sorilList({
          angi: this.angiId,
          bagts: this.bagtsId,
          sorilNo: this.levelId,
        });
        this.questionIdList = resp.data;
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  async mounted() {
    if (this.$route.params.lid !== undefined) {
      localStorage.setItem("level", this.$route.params.lid);
    } else {
      this.$route.push({ path: "/" });
    }

    this.categoryId = localStorage.getItem("category");
    this.angiId = localStorage.getItem("angi");
    this.bagtsId = localStorage.getItem("bagts");
    this.levelId = localStorage.getItem("level");

    this.start = false;

    await this.loadQuestionList();

    setInterval(() => {
      this.count = this.count - 1;
    }, 1000);
  },
  watch: {
    count: function (val) {
      if (!this.testEnd) {
        if (val < -1) {
          this.timeOut();
        }
      } else {
        this.count = 1200;
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.test-content {
  background: url("../assets/images/test-back.png");
  background-color: #fff;
  min-height: 80vh;
}

.task-container {
  max-width: 1200px;
  margin: 0 auto 0 auto;
  padding: 120px 0px 180px 0px;
  position: relative;
}
/*Цаг*/
.card {
  position: absolute;
  z-index: 12;
  left: 102%;
  top: 0%;
  border: none;
  border-radius: 1.25em;
}
.card-header {
  text-align: center;
  background-color: #26a3db;
  color: #fff;
  font-weight: 550;
  border: 1px solid #26a3db;
  padding: 5px;
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
}
.card-body {
  padding: 10px 10px 0px 10px;
  border: 2px solid #f3f3f3;
  border-bottom-left-radius: 0.8em;
  border-bottom-right-radius: 0.8em;
}
.time {
  display: flex;
  flex-direction: column;
  min-width: 80px;
  text-align: center;
}
.time-now {
  font-size: 1.875em;
  color: #00000;
  font-weight: 550;
}
.time-label {
  display: flex;
  justify-content: space-around;
  color: #6d6d6d;
  font-size: 0.75em;
  margin-top: -10px;
}
/*Task css*/
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px;
  font-family: "Times New Roman";
  border-radius: 1.25em;
  position: relative;
  border: 1px solid #26a3db;
}
.task {
  font-size: 1.4em;
  margin-bottom: 20px;
}
.ans {
  font-size: 1.4em;
}
.choice-content-solution {
  display: flex;
  flex-wrap: wrap;
}

.choice-body-solution {
  margin-top: 20px;
  display: flex;
  border-radius: 1.25em;
  background-color: #dfe6e9;
}
.choice-body {
  cursor: pointer;
  display: flex;
  padding: 0.2em;
  border-radius: 1.25em;
  background-color: #dfe6e9;
  min-width: 155px;
  min-height: 62px;
  margin: 20px;
}
.choice-body.selected {
  background-color: #52b700;
}

.task-text-order {
  font-size: 1.55em;
  font-family: roboto;
  padding-right: 8px;
}
.choice-letter {
  padding: 0 14px;
  text-align: center;
  cursor: pointer;
  font-size: 2em;
  color: #000000;
}
.choice-value {
  min-width: 102px;
  max-width: 400px;
  overflow-wrap: break-word;
  text-align: center;
  background-color: #fff;
  border-bottom-right-radius: 1.25em;
  border-top-right-radius: 1.25em;
  height: auto;
  color: #000000;
}
.choice-value >>> p {
  margin: 0;
  font-family: "Times New Roman";
  font-size: 2em;
}
.choice-value >>> img {
  border-bottom-right-radius: 15px;
  border-top-right-radius: 15px;
  padding: 3px;
}
.task-score {
  color: #2ecc71;
}
.btn {
  min-width: 135px;
  min-height: 32.98px;
  border-radius: 12px;
  font-size: 1.25em;
  margin-top: 20px;
}

.fn {
  background-color: #fff;
  position: absolute;
  /* border: 1px solid #26a3db; */
  border: 1px solid #a1a1a1;
  border-radius: 50%;
  top: 50%;

  z-index: unset;
  transform: translate(-50%, -50%);
}
.fa-question-circle {
  color: #52b700;
  font-size: 1.5em;
  padding: 10px;
  left: -1.5%;
  z-index: 1;
}

.fa-dice-five {
  color: #f9850c;
  font-size: 2em;
  padding: 10px 12px 10px 12px;
  left: 0.2%;
}

.loading-task {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.grey-container {
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
..bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
